export default __webpack_public_path__ + "static/media/fad-logo-lv2.59fa60e0.svg";